// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignsRoute_container__2npVa","mainContainer":"CampaignsRoute_mainContainer__1O_2H"};